import { getDataWithParams } from "../helpers/apiHelper2";
import { getDataWithParams as getDataWithParamsV3 } from "../helpers/apiHelperV3";
import { urls } from "./urls";

import type { Pagination } from "app/types/paginateType";

const API_REPORTS = "/reports/";

/**
 * fetch settled report list
 */
export const fetchSettledReportList = (payload: any): any => {
  //parmas will be passed down to here
  const params = {};
  params["sport-id"] = payload && payload.selectedSportId;
  params["participant"] = payload && payload.event;
  params["after"] = payload && payload.after;
  params["before"] = payload && payload.before;
  params["offset"] = payload && payload.offset;
  let perPage = 200;
  // BET-2079
  if (payload.perPage !== undefined) perPage = payload.perPage;
  const url = API_REPORTS + "bets/settledWithMultipliers?per-page=" + perPage;
  return getDataWithParams(url, params);
};

/**
 * fetch transactions report list from API v3
 */

export interface FetchTransactionsReportListPayload extends Pagination {
  after: string;
  before: string;
  transactionType: string;
  participant: string;
}

export const fetchTransactionsReportList = (payload: any): any => {
  const url = urls.reports.API_REPORTS_MOBILE_TRANSACTIONS();

  const params: Record<string, unknown> = {};
  params["size"] = payload.size ?? 200;
  params["page"] = payload && payload.page;
  params["after"] = payload && payload.after;
  params["before"] = payload && payload.before;
  params["participant"] = payload && payload.participant;

  if (payload.transactionType !== undefined && payload.transactionType !== "") {
    params["show"] = payload && payload.transactionType;
  }

  return getDataWithParamsV3(url, params);
};
